import axios from 'axios';

/**
   * Liste des actions
 */
export const Actions = {
    FETCH_SUGGESTIONS_AGENCE_REQUEST: 'FETCH_SUGGESTIONS_AGENCE_REQUEST',
    FETCH_SUGGESTIONS_AGENCE_SUCCESS: 'FETCH_SUGGESTIONS_AGENCE_SUCCESS',
    FETCH_SUGGESTIONS_AGENCE_FAILURE: 'FETCH_SUGGESTIONS_AGENCE_FAILURE',

    CLEAR_SUGGESTIONS_AGENCE: 'CLEAR_SUGGESTIONS_AGENCE',

    SET_AGENCE_VALUE: 'SET_AGENCE_VALUE',
    CLEAR_AGENCE_VALUE: 'CLEAR_AGENCE_VALUE'
};



/**
 * ActionCreator pour FETCH_SUGGESTIONS_...
 */
const fetchSuggestionsAgenceRequest = () => ({
    type: Actions.FETCH_SUGGESTIONS_AGENCE_REQUEST
});
const fetchSuggestionsAgenceSuccess = agences => ({
    type: Actions.FETCH_SUGGESTIONS_AGENCE_SUCCESS,
    agences
});
const fetchSuggestionsAgenceFailure = error => ({
    type: Actions.FETCH_SUGGESTIONS_AGENCE_FAILURE,
    error
});

/**
 * ActionCreator pour la récuperation des données (suggestions)
 */
export const fetchSuggestionsAgence = (searchValue) => async (dispatch) => {
    dispatch(fetchSuggestionsAgenceRequest());

    try {
        let response = await axios.get('api/agences/suggestion?query=' + searchValue);

        dispatch(fetchSuggestionsAgenceSuccess(response.data));

    } catch (error) {
        dispatch(fetchSuggestionsAgenceFailure(error));
    }
};

/**
 * ActionCreator pour CLEAR_SUGGESTIONS_AGENCE
 */
export const clearSuggestionsAgence = () => ({ type: Actions.CLEAR_SUGGESTIONS_AGENCE });



/**
 * ActionCreator pour SET_AGENCE_VALUE
 */
export const setAgenceValue = (value, selectedId) => ({ type: Actions.SET_AGENCE_VALUE, value, selectedId });

/**
 * ActionCreator pour CLEAR_AGENCE_VALUE
 */
export const clearAgenceValue = () => ({ type: Actions.CLEAR_AGENCE_VALUE });
